import React from 'react';
import ReactDOM from 'react-dom';
import { loadRuntimeConfig } from './config/runtime';

const renderBootError = () => {
  ReactDOM.render(
    <div style={{ padding: '24px', fontFamily: 'Arial, sans-serif' }}>
      Unable to load application configuration.
    </div>,
    document.getElementById('root')
  );
};

const bootstrap = async () => {
  try {
    await loadRuntimeConfig();
    const { renderApp } = await import('./bootstrap');
    renderApp();
  } catch (error) {
    console.error('Application bootstrap failed:', error);
    renderBootError();
  }
};

bootstrap();
